/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SecurityCatchUpRightsBasis {
    DISTRIBUTIONS_TO_SECURITIES_IN_HIGHER_OR_EQUAL_RANK = 'DISTRIBUTIONS_TO_SECURITIES_IN_HIGHER_OR_EQUAL_RANK',
    DISTRIBUTIONS_TO_SECURITIES_IN_HIGHER_RANK = 'DISTRIBUTIONS_TO_SECURITIES_IN_HIGHER_RANK',
}
